import styled from '@emotion/styled';

import Notice from 'components/Kizen/Notice';

export const APIKeysNotice = styled(Notice)`
  margin-top: 5px;
  margin-bottom: 20px;
`;
